import * as constants from '../constants/queueActionTypes';

export function getAllQueues() {
  return (dispatch) => {
    dispatch({
      type: constants.QUEUES_GET_ALL,
    });
  };
}
